import type { CountryFinancialProfile } from "./types";

/**
 * Bulgaria — verified 2026 legal parameters.
 *
 * These are the same constants the BG calculators already used; they are
 * extracted here so the calculation engines stay country-agnostic. The
 * numeric values are unchanged, so BG results are unchanged.
 */
const NAP = "https://nra.bg/";
const KSO = "https://lex.bg/laws/ldoc/1597824512";
const ZDDFL = "https://lex.bg/laws/ldoc/2135538631";

export const BG_PROFILE: CountryFinancialProfile = {
  country: "BG",
  primaryCurrency: "EUR",
  secondaryCurrency: null,
  intlLocale: "bg-BG",
  dateFormat: "dd.MM.yyyy",
  parameters: [
    {
      key: "minWage",
      label: "Минимална работна заплата 2026",
      value: 620.2,
      unit: "eur-per-month",
      sourceUrl: NAP,
      verifiedAt: "2026-08-15",
      status: "verified",
    },
    {
      key: "maxInsurableIncomeH1",
      label: "Максимален осигурителен доход (01.01–31.07.2026)",
      value: 2111.64,
      unit: "eur-per-month",
      sourceUrl: KSO,
      verifiedAt: "2026-08-15",
      status: "verified",
    },
    {
      key: "maxInsurableIncomeH2",
      label: "Максимален осигурителен доход (от 01.08.2026)",
      value: 2300,
      unit: "eur-per-month",
      sourceUrl: KSO,
      verifiedAt: "2026-08-15",
      status: "verified",
    },
    {
      key: "employeeContributionRate",
      label: "Осигуровки за сметка на служителя (III категория)",
      value: 0.1378,
      unit: "percent",
      sourceUrl: KSO,
      verifiedAt: "2026-08-15",
      status: "verified",
    },
    {
      key: "pitRate",
      label: "Данък върху доходите на физическите лица",
      value: 0.1,
      unit: "percent",
      sourceUrl: ZDDFL,
      verifiedAt: "2026-08-15",
      status: "verified",
    },
    {
      key: "dividendTaxRate",
      label: "Данък върху дивиденти",
      value: 0.05,
      unit: "percent",
      sourceUrl: ZDDFL,
      verifiedAt: "2026-08-15",
      status: "verified",
    },
  ],
  legalCalculators: {
    "net-salary": "verified",
    "civil-contract": "verified",
    "work-experience": "verified",
    "euro-conversion": "verified",
  },
  universalCalculators: ["compound", "dca", "dividends", "mortgage", "broker-fees"],
};
